
export default function Produce() {
        return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">
      {/* Department Title */}
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-10">
            Produce
          </h2>

      {/* Image Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-5xl">
        <img
          src="/assets/produce3.jpg"
          alt="Fresh vegetables"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="/assets/produce2.jpg"
          alt="Fruits"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="/assets/produce1.jpg"
          alt="Leafy greens"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
      </div>

      {/* Description */}
      <div className="max-w-3xl text-center p-6">
        <p className="text-gray-700 text-lg leading-relaxed">
          Our Produce Department offers the freshest fruits and vegetables sourced
          daily from local farms and trusted suppliers. Whether you're looking for
          crisp greens, vibrant berries, or seasonal favorites, you’ll find only
          the best quality ingredients here, perfect for healthy meals and snacks.
        </p>
      </div>
    </div>
  );
}